module.exports = __webpack_public_path__ + "img/empty-plans.8ab7a150.svg";